import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, getPermissions, GetPermissionsResponse, QueryDefaults } from 'api';

export const usePermissions = (): QueryObserverResult<GetPermissionsResponse> =>
  useQuery([API_QUERY_KEYS.getPermissions], getPermissions, QueryDefaults);
